import React, { useState } from "react";
import NiceModal, { useModal } from "@ebay/nice-modal-react"
import Modal from "/src/components/modal/Modal";
import ButtonAction from "/src/components/UI/Button/Button";
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import Form from "/src/components/form/Form";
import "./ImportPhonesModal.css"
import "/src/assets/css/polices.css";
import ChooseFile from "/src/components/UI/ChooseFile/ChooseFile";
import FormData from 'form-data';
import phoneService from "../../../services/phoneService";

const ImportPhonesModal = NiceModal.create(({ nameBot, title, data }) => {
    const modal = useModal();
    const {importPhones} = phoneService;
    
    const { onClose } = useModalHelper(modal);
    const [file, setFile] = useState();

    const [loadAnim, setLoading] = useState(null);
    const onSubmit = async () => {

        const formData = new FormData();

        formData.append('phones', file);
        let [response, error] = await importPhones(formData)
        if (error !== null) {
            console.log(error);
            return;
        }
        setLoading("finish")
        setTimeout(() => {onClose() }, 2000)
    }

    function timeout(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
    return (
        <Modal name="change-password" id={modal.id} autoClose="true" onClose={onClose}>
            <div className="leave-container">
                <div className="button-leave" id="close_modal_container" onClick={() => onClose({idIconModal:"close_modal_container"})} >
                    <i id="close_modal" className="fa fa-times" aria-hidden="true"></i>
                </div>
            </div>
            <Form className="form-import">
                <Form.Title>Import some Phone Numbers</Form.Title>
                <Form.Body className="form-import_body">
                    <ChooseFile _setFile={setFile} accept=".xlsx,.csv" loadAnim={loadAnim}></ChooseFile>
                </Form.Body>
                <Form.Buttons>
                    <div className="button_center">
                        <ButtonAction className="validate" label="Upload" disabled={file != null ? false : true} onClick={() => { onSubmit(); setLoading(true) }} />
                    </div>
                </Form.Buttons>
            </Form>
        </Modal >
    )
});

export default ImportPhonesModal;